export interface IFiltroTitulo {

  CE1PREFIXO: string;
  CE1FILIAL: string;
  CE1NUM: string;
  CE1PARCELA: string;
  CE1TIPO: string;
  CE1CLIENTE: string;
  CE1LOJA: string;
  CSITUACAO: string;

  order: string;

}

export class FiltroListaTitulo {

    dados: IFiltroTitulo;

    constructor() {
      this.dados = this.setDefault();
    }

    public setDefault = (): IFiltroTitulo => {
      return {
        CE1PREFIXO: '',
        CE1FILIAL: '',
        CE1NUM: '',
        CE1PARCELA: '',
        CE1TIPO: '',
        CE1CLIENTE: '',
        CE1LOJA: '',
        CSITUACAO: 'A',
        order: '',
      };
    }

  }
